export default __webpack_public_path__ + "static/media/analyticsIcon.3000b4d8.svg";